import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadCollections: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { collectionApi },
) =>
  action$.pipe(
    ofType(actions.COLLECTIONS_ACTIONS.REQUESTED),
    switchMap(() =>
      collectionApi.getCollections().pipe(
        switchMap(({ collections }) =>
          of(actions.collectionsSucceeded(collections)),
        ),
        catchError(error => of(actions.collectionsFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/epics/loadCollections.ts